<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <div class="search-box">
    <div class="input-group input-group-sm">
      <input
      #searchPlaces
      [placeholder]="loading ? 'Loading...' : ''"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="off"
      [(ngModel)]="address"
      type="text"
      class="form-control"
      [disabled]="loading">
      <button
        class="btn btn-secondary text-white"
        type="button"
        (click)="doSearch()"
        [disabled]="!address || loading">
        Search
      </button>
    </div>
  </div>
  <google-map
  [center]="{ lat: search.latitude, lng: search.longitude }"
  [options]="mapOptions"
  width="100%"
  (mapClick)="updateMarker($event)"
  >
  <map-marker
    [position]="{ lat: marker.latitude, lng: marker.longitude }"
    [draggable]="true"
    (dragEnd)="updateMarker($event)">
  </map-marker>
</google-map>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" ngbAutofocus (click)="activeModal.dismiss()">
    Cancel
  </button>
  <button
    type="button"
    [disabled]="!marker.latitude || !marker.longitude"
    class="btn btn-success text-white"
    (click)="select()"
    [disabled]="loading || !address">
    Select
  </button>
</div>
